<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card v-if="dialog">
            <v-card-title class="primary white--text title">
                {{ 'Graphic'|translate }}
            </v-card-title>
            <v-card-text>
                <v-layout>
                    <v-flex :class="type==='3D' ? 'xs8' : 'xs12'">
                        <v-text-field :label="'Name'|translate" v-model="name" :disabled="readOnly"></v-text-field>
                        <v-text-field :label="'Floor'|translate" v-model="floor" :disabled="readOnly"></v-text-field>
                        <v-select
                            :items="types"
                            label="Type"
                            v-model="type"
                            required
                            :disabled="readOnly"
                        ></v-select>
                        <v-text-field :label="'3D Model link'|translate" v-model="config.link" v-if="!readOnly&&type==='3D'"></v-text-field>
                        <v-text-field :label="'Height'|translate" v-model.number="config.height" v-if="!readOnly&&type==='3D'"></v-text-field>
                        <v-switch color="success"  :label="'Latest Only'|translate" v-model="config.latestOnly" v-if="!readOnly&&type==='SVG'"></v-switch>
                        <editor v-model="config.svg" @init="svgEditorInit" lang="svg" theme="twilight" width="100%" height="400" v-if="!readOnly&&type==='SVG'"></editor>
                        <forge-viewer-widget v-if="type==='3D'&&config.link&&config.link!==''" :url="config.link" :height="config.height" @select="handle3DSelect" :selected-items="selectorControl"></forge-viewer-widget>
                        <bms-widget v-if="!readOnly&&type==='SVG'&&svgPreview" :latest-only="config.latestOnly" :svg="svgPreview"></bms-widget>
                        <bms-widget v-if="readOnly&&type==='SVG'" :latest-only="config.latestOnly" :svg="config.svg"></bms-widget>
                    </v-flex>
                    <v-flex xs4 v-if="type==='3D'">
                        <div class="ml-3" v-if="config.link&&config.link!==''&&config.mappings" style="max-height:1200px; overflow-y: auto;" >
                            <v-subheader>{{'Mappings'|translate}}</v-subheader>
                            <v-layout v-for="(mapping, index) in config.mappings">
                                <v-flex xs1>
                                    <v-icon class="mt-4" small color="success" v-if="selected3dItem&&selected3dItem===mapping.id">fa-bullseye</v-icon>
                                    <v-icon class="mt-4" small v-if="!selected3dItem||selected3dItem!==mapping.id" @click="manSelect(mapping.id)">fa-bullseye</v-icon>
                                </v-flex>
                                <v-flex xs4><v-text-field v-model="mapping.id" label="Item ID" disabled>
                                </v-text-field></v-flex>
                                <v-flex xs6 v-if="!readOnly"><equipment-selector v-model="mapping.equipmentName"></equipment-selector></v-flex>
                                <v-flex xs1 v-if="!readOnly"><v-icon small class="ml-3 mt-4" @click="config.mappings.splice(index,1)">fa-trash</v-icon></v-flex>
                                <v-flex xs7 v-if="readOnly"><div class="mt-4">{{mapping.equipmentName}}</div></v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions v-if="!readOnly">
                <v-btn class="primary ml-2 elevation-4" v-if="selected3dItem&&type==='3D'&&config.link&&config.link!==''&&canMap" @click="mapItem">{{ 'Map selection'|translate }}</v-btn>
                <v-btn class="primary ml-2 elevation-4" v-if="!readOnly&&type==='SVG'&&config.svg&&config.svg" @click="runPreview">{{ 'Render SVG'|translate }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
                <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!$can('update', 'Graphic')||!name||name===''">
                    {{ 'Save'|translate }}
                </v-btn>
            </v-card-actions>
            <v-card-actions v-if="readOnly">
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="dialog=false">{{ 'Close'|translate }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {putGraphic} from '../helper'
import ForgeViewerWidget from "./widgets/ForgeViewerWidget";
import EquipmentSelector from "./EquipmentSelector";
import BmsWidget from "./widgets/BmsWidget";
import editor from 'vue2-ace-editor'

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null},
        readOnly: {type: Boolean, default: false}
    },
    components: {EquipmentSelector, ForgeViewerWidget,editor,BmsWidget},
    computed: {
        canMap(){
            return this.selected3dItem&&(!this.config.mappings||this.config.mappings.filter(x=>x.id===this.selected3dItem).length===0)
        }

    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                this.selected3dItem=null
                this.svgPreview=null
                this.selectorControl = []
                this.graphic_id = item['graphic_id']
                this.name = item['name']
                this.type = item['type']
                this.floor = item['floor']
                this.config = item['config']
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
            if(!this.dialog){
                this.initializeVar()
            }
        }
    },
    data() {
        return {
            selected3dItem:null,
            selectorControl:[],
            types: ['3D', 'SVG'],
            dialog: false,
            graphic_id: null,
            name: null,
            type: '3D',
            floor: null,
            svgPreview: null,
            config:{
                height:600,
                svg:""
            },


        }
    },
    methods: {
        svgEditorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/svg')
            require('brace/theme/twilight')
        },
        manSelect(id){
            this.selectorControl=[id]
        },
        runPreview(){
            this.svgPreview=null
            let me=this
            setTimeout(function(){
                me.svgPreview=me.config.svg
            },1000)
        },
        initializeVar() {
            this.selected3dItem = null
            this.selectorControl = []
            this.type = '3D'
            this.svgPreview = null
            this.graphic_id = null
            this.name = null
            this.floor = null
            this.config = {
                height:600,
                svg:""
            }
        },
        async addRecord() {
            await putGraphic(
                {
                    'graphic_id': this.graphic_id,
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'name': this.name,
                    'type': this.type,
                    'floor': this.floor,
                    'config': this.config
                }
            )
            this.$emit('doreload')
            this.dialog = false
        },
        handle3DSelect(data){
            if(data&&data.dbIdArray&&data.dbIdArray.length===1){
                this.selected3dItem=data.dbIdArray[0]
            } else {
                this.selected3dItem=null
            }
        },
        mapItem(){
            if(!this.config.mappings){
                this.config.mappings=[]
            }
            this.config.mappings.push({
                id:this.selected3dItem,
                equipmentName:null
            })
            this.selected3dItem=null
        }

    },
    name: 'Graphic'
}
</script>

<style scoped>

</style>
